import { NotificationsState } from '@/app/module/notifications/types'

const state: NotificationsState = {
  data: {},
}

export default state
